export default __webpack_public_path__ + "static/media/about_us_david.3d92eb50.png";